import { render, staticRenderFns } from "./ProjectMilestoneNew.vue?vue&type=template&id=b517a0c2&"
import script from "./ProjectMilestoneNew.vue?vue&type=script&lang=js&"
export * from "./ProjectMilestoneNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports